import gql from 'graphql-tag';

export default gql`
  mutation UpdateOfficePicture(
    $accountId: ID!
    $officeId: ID!
    $identityId: ID!
    $filename: String!
  ) {
    updateOfficePicture(
      accountId: $accountId
      officeId: $officeId
      identityId: $identityId
      filename: $filename
    ) {
      id
      name
      img {
        medium
      }
    }
  }
`;
